import { useTranslation } from 'react-i18next'
import { useHasFeature, useSelectedAccountId } from '../../hooks/useSubscription'
import FontSelector from '../FontSelector/FontSelector'

function FontPreferenceSection({ defaultFont, onFontChange }) {
  const { t } = useTranslation('settings')
  const accountId = useSelectedAccountId()

  // Check if user has access to pro fonts
  const { hasFeature: hasProFonts } = useHasFeature('pro_fonts', accountId)

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-semibold text-gray-900">
          {t('font.title', 'Default Caption Font')}
        </h2>
        <p className="text-gray-600 mt-1">
          {t('font.description', 'Choose a default font for your captions. You can override this when uploading images.')}
        </p>
      </div>

      <FontSelector
        selectedFont={defaultFont}
        onFontChange={onFontChange}
        hasProAccess={hasProFonts}
      />

      {/* Info Box */}
      <div className="bg-purple-50 border border-purple-200 rounded-lg p-4">
        <div className="flex">
          <svg className="h-5 w-5 text-purple-600 mr-3 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
          </svg>
          <div className="text-sm text-purple-800">
            <p className="font-medium">{t('font.infoTitle', 'Font Rendering')}</p>
            <p className="text-purple-700 mt-1">
              {t('font.infoText', 'The selected font will be used when rendering text on your images. Pro fonts require an active Pro or Premium subscription.')}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FontPreferenceSection
